import * as THREE from 'three';
import { useGLTF } from '@react-three/drei';
import { useLocation } from 'react-router-dom';

export default function Generator({ truckPos, opacity = 1, ...props }) {
    const location = useLocation(); 

    const glowBlue = new THREE.MeshBasicMaterial({ 
        color: new THREE.Color(0, 0.3, 20),
        toneMapped: false,
        transparent: true,
        opacity: opacity 
    });

    const normalMaterial = new THREE.MeshBasicMaterial({
        color: new THREE.Color(1, 1, 1),
        toneMapped: false,
        transparent: true,
        opacity: opacity
    });

    const tracks = useGLTF('./models/tracks.glb');

    
    const trackRanges = [
        { min: 0.116, max: 0.12 },
        { min: 0.116, max: 0.12228 },
        { min: 0.12224, max: 0.12878 },
        { min: 0.12852, max: 0.1348 },
        { min: 0.13506, max: 0.141522 },
        { min: 0.141262, max: 0.147802 },
        { min: 0.147373, max: 0.154336 },
        { min: 0.154286, max: 0.160899 },
        { min: 0.160665, max: 0.167369 },
        { min: 0.167155, max: 0.167629 },
        { min: 0.173569, max: 0.180224 },
        { min: 0.179991, max: 0.186582 },
        { min: 0.186404, max: 0.193074 },
        { min: 0.192790, max: 0.199503 },
        { min: 0.199252, max: 0.205895 },
        { min: 0.205613, max: 0.212400 },
        { min: 0.212198, max: 0.218799 },
        { min: 0.218555, max: 0.225269 },
        { min: 0.224998, max: 0.231575 },
        { min: 0.231334, max: 0.238078 },
        { min: 0.237817, max: 0.244525 },
        { min: 0.244329, max: 0.250983 },
        { min: 0.250749, max: 0.257334 },
        { min: 0.257100, max: 0.263661 },
        { min: 0.263642, max: 0.270208 },
        { min: 0.269954, max: 0.276667 },
        { min: 0.276473, max: 0.283039 },
        { min: 0.282793, max: 0.289435 },
        { min: 0.289193, max: 0.295902 },
        { min: 0.295679, max: 0.302368 },
        { min: 0.302130, max: 0.308797 },
        { min: 0.308583, max: 0.315093 },
        { min: 0.315074, max: 0.321648 },
        { min: 0.321287, max: 0.327966 },
        { min: 0.327699, max: 0.334500 },
        { min: 0.334213, max: 0.340845 },
        { min: 0.340744, max: 0.347363 },
        { min: 0.347115, max: 0.353280 },
    ];

    const getTrackMaterial = (index) => {
        const range = trackRanges[index];
        if (range && truckPos >= range.min && truckPos <= range.max) {
            if(location.pathname === "/smartpowering" || location.pathname === "/charge" || location.pathname === "/captation"){
                return glowBlue;
            }else{
                return normalMaterial;
            }
        }
        return normalMaterial;
    };

    return (
        <group {...props} dispose={null}>
            {Object.keys(tracks.nodes).map((key, index) => {
                if (key.startsWith('track_')) {
                    return (
                        <mesh
                            key={index}
                            geometry={tracks.nodes[key].geometry}
                            material={getTrackMaterial(index)}
                            position={[-4, 5.72, -59.1]}
                        />
                    );
                }
                return null;
            })}
        </group>
    );
}
